/**
 * Created by Ivan on 10.08.2026
 */

const SeasonCollectionsStartTutorial2 = function () {
    return new TutorialScenario(SeasonCollectionsStartTutorial2.NAME, {
        listSteps: SeasonCollectionsStartTutorial2.listSteps,

        isAvailable: function () {
            return false;
        }
    });
};

SeasonCollectionsStartTutorial2.listSteps = function () {
    return [
        SeasonCollectionsStartTutorial2.createDialogueStep(),
        SeasonCollectionsStartTutorial2.createSeasonWindowStep(),
        SeasonCollectionsStartTutorial2.createRewardWindowStep()
    ];
};

SeasonCollectionsStartTutorial2.createDialogueStep = function () {
    return new TutorialStep({
        onStart: function () {
            const bundleName = `stickers2_book_season_dialogue_${cleverapps.stickersBook2.season}`;
            const seasonBundle = bundles[bundleName];
            if (!seasonBundle || !seasonBundle.jsons.dialogues_json) {
                this.finish();
                return;
            }

            cleverapps.bundleLoader.loadBundle(bundleName, {
                onSuccess: () => {
                    const dialogueData = seasonBundle.jsons.dialogues_json.getJson();
                    if (!dialogueData) {
                        this.finish();
                        return;
                    }
                    const dialogue = new Dialogue(dialogueData, {
                        autoClose: true,
                        autoScroll: false,
                        showUp: true
                    });

                    dialogue.on("afterClose", () => {
                        this.finish();
                    });

                    new DialogueView(dialogue);
                }
            });
        },

        onFinish: function () {
            cleverapps.tutorial.startNextStep();
        }
    });
};

SeasonCollectionsStartTutorial2.createSeasonWindowStep = function () {
    return new TutorialStep({
        onStart: function () {
            new StickersBookSeasonWindow2({ isCompleted: false });
            cleverapps.focusManager.onceNoWindowsListener = this.finish.bind(this);
        },

        onFinish: function () {
            cleverapps.tutorial.startNextStep();
        }
    });
};

SeasonCollectionsStartTutorial2.createRewardWindowStep = function () {
    return new TutorialStep({
        onStart: function () {
            cleverapps.stickersBook2.givePrize(4, Sticker2.SOURCES.tutorial);
            new StickersRewardWindow2(true);
            cleverapps.focusManager.onceNoWindowsListener = this.finish.bind(this);
        },

        onFinish: function () {
            cleverapps.tutorial.startNextStep();
        }
    });
};

SeasonCollectionsStartTutorial2.NAME = "season_collections2_start_tutorial";